/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Browser auth mode is a build-time shell capability, not a product-code
 * hardcode. APPLICATION keeps qpa HttpOnly and disables tenant/company scope
 * in the shared shell.
 */

export type BrowserAuthPrincipalMode = 'TENANT' | 'APPLICATION';

export function getBrowserAuthPrincipalMode(): BrowserAuthPrincipalMode {
  const raw = String(import.meta.env.VITE_AUTH_PRINCIPAL_MODE ?? 'TENANT')
    .trim()
    .toUpperCase();
  if (raw === 'TENANT' || raw === 'APPLICATION') return raw;
  throw new Error('VITE_AUTH_PRINCIPAL_MODE yalnız TENANT veya APPLICATION olabilir.');
}

export function isApplicationBrowserAuthMode(): boolean {
  return getBrowserAuthPrincipalMode() === 'APPLICATION';
}
